import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthResultCard = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [result, setResult] = useState(null);

  // 从URL参数中获取ID
  const getUrlId = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get('id');
  };

  // 查询验证结果
  const fetchAuthResult = async () => {
    setIsLoading(true);
    const id = getUrlId();
    
    if (!id) {
      console.error('URL中缺少身份标识参数');
      navigate('/mpbind/student-info');
      return;
    }

    try {
      const response = await fetch('api/auth-logs/face-auth', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ id })
      });

      if (!response.ok) {
        throw new Error(`网络请求失败: ${response.status}`);
      }

      const data = await response.json();
      
      // 处理API响应
      if (data.code === 0 && data.facePass === true) {
        setResult(data);
      } else {
        // 验证失败或API错误时跳转
        navigate('/mpbind/student-info');
      }
    } catch (err) {
      console.error(err.message);
      navigate('/mpbind/student-info');
    } finally {
      setIsLoading(false);
    }
  };

  // 组件挂载时执行查询
  useEffect(() => {
    fetchAuthResult();
  }, []);

  // 验证通过后立即跳转
  useEffect(() => {
    if (result && result.facePass === true) {
      const id = getUrlId();
      window.location.href = `./phone-verification?id=${id}`;
    }
  }, [result]);

  // 重新验证
  const handleRetry = () => {
    setResult(null);
    fetchAuthResult();
  };

  return (
    <div className="container">
      <div className="card">
        <div className="card-header">
          <img 
            src="/logo.png" alt="泉州师范学院" 
            className="header-logo"
          />
          <h1>人脸验证结果查询</h1>
        </div>
        
        <div className="card-body">
          {isLoading ? (
            <div className="text-center">
              <i className="fas fa-spinner fa-spin fa-3x" style={{color: "#db1f26"}}></i>
              <h3 className="mt-3">正在查询验证结果</h3>
              <p className="hint">请稍候，正在与服务器通信...</p>
            </div>
          ) : result?.facePass === true ? (
            <div className="result success">
              <i className="fas fa-check-circle fa-3x"></i>
              <h3>人脸验证通过</h3>
              <div className="info-section mt-4">
                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-user-check"></i>
                  </div>
                  <div className="info-content">
                    <div className="info-label">验证状态</div>
                    <div className="info-value">已验证通过</div>
                  </div>
                </div>
                <div className="info-item">
                  <div className="info-icon">
                    <i className="fas fa-clock"></i>
                  </div>
                  <div className="info-content">
                    <div className="info-label">验证时间</div>
                    <div className="info-value">{new Date().toLocaleString()}</div>
                  </div>
                </div>
              </div>
              <button 
                className="btn mt-3" 
                onClick={() => {
                  const id = getUrlId();
                  window.location.href = `http://localhost:8062/phone-verification?id=${id}`;
                }}
              >
                立即跳转 <i className="fas fa-arrow-right"></i>
              </button>
            </div>
          ) : null}
          
          <div className="mt-4 text-center">
            <p className="hint">查询ID: {getUrlId() || '未提供'}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthResultCard;